import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Folders
const FoldersListPage = lazy(
  () => import("@/shared/folders/pages/folders-list")
);
// const FoldersViewPage = lazy(
//   () => import("@/features/folders/pages/folders-view")
// );

export const foldersRoutes: RouteObject[] = [
  {
    path: "/admin/folders",
    element: (
      <RequirePermission resource="folders">
        <FoldersListPage />
      </RequirePermission>
    ),
  },
  // {
  //   path: "/admin/folders/:folderPath",
  //   element: <FoldersListPage />,
  // },
];
